<template>
  <span
    :class="{
      'online-indicator--active': isCurrentlyOnline,
    }"
    class="online-indicator" />
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'OnlineIndicator',

  props: {
    userId: {
      type: Number,
      default: null,
    },

    isOnline: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapState('onlineUsers', ['state']),

    isCurrentlyOnline() {
      // нет юзера - не за кем следить, работаем только с пропсом
      if (!this.userId) {
        return this.isOnline;
      }

      const fakeIds = process.env.CURRENCY_MARKETPLACE_SKY_FAKE_PROS_IDS
        ? process.env.CURRENCY_MARKETPLACE_SKY_FAKE_PROS_IDS.split(',') : [];

      if ([
        process.env.CURRENCY_MARKETPLACE_SKY_PRO_ID,
        ...fakeIds,
      ].includes(this.userId.toString())) {
        return true;
      }

      // смотрим в онлайн стейт, если есть данные - берём оттуда, иначе из пропса
      return this.state?.[this.userId]?.is_online !== undefined ? this.state[this.userId].is_online : this.isOnline;
    },
  },

  mounted() {
    this.track(this.userId);
  },

  beforeDestroy() {
    this.unTrack(this.userId);
  },

  methods: {
    ...mapActions('onlineUsers', ['track', 'unTrack']),
  },
};
</script>

<style lang="scss" scoped>
  .online-indicator {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background: $color--basic-light-gray;
  }

  .online-indicator--active {
    background: $color--basic-green;
  }
</style>
